/**
 * useEffectiveRole — die für Access-Checks anzuwendende Rolle.
 *
 * Standardfall: `profile.role` aus dem AuthContext. Im aktiven Support-
 * Modus „verkleidet" sich ein Plattform-Admin (`role === 'admin'`) als
 * `org_admin` der Ziel-Org, damit er die Sidebar und die Routen genau so
 * sieht wie ein lokaler Org-Admin — sonst würde die roles-Whitelist
 * sämtliche Workflow-Routen blockieren. Ob die Ziel-Org praxis oder
 * klinik ist, entscheidet weiterhin `settingType` (Scope), nicht die
 * Rolle — deshalb reicht hier ein einziger Rückgabewert für beide Fälle.
 *
 * Schreibzugriffe bleiben in Phase 1 weiterhin geblockt (siehe
 * SupportModeContext-Header) — die effektive Rolle dient nur der UI-
 * Sichtbarkeit, nicht der Berechtigung gegenüber Supabase.
 */

import { useAuth } from '@/contexts/AuthContext';
import { useSupportMode } from '@/contexts/SupportModeContext';
import type { Role } from '@/features/types';

export function useEffectiveRole(): Role | undefined {
  const { profile } = useAuth();
  const { active: isSupportMode } = useSupportMode();

  if (isSupportMode && profile?.role === 'admin') {
    return 'org_admin';
  }
  return profile?.role;
}
